import React, { useContext } from 'react';
import { BiEventType, ReferralType } from '@wix/da-bi/pkg/constants';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import DeviationDuperbrowseContext from '../../../../Duperbrowse/DeviationDuperbrowseContext';
import { getDeviationResourceType, getDeviationType, } from '../../../../DeviationViews/_helpers';
import TierSidebarCard from '../../../../DeviationViews/TierSidebarCard';
import SidebarBlockWrapper from '../../../_partials/SidebarBlockWrapper';
import { ResourceType } from '../../../../types/resource';
import { useSubscriptionTier } from '../../../../utils/hooks/useSubscriptionTier';
import { useSubscriptionLockFTUE } from '../../../../Tier/ftue/useSubscriptionLockFTUE';
import SubscriptionLockFTUE from '../../../../Tier/ftue/SubscriptionLockFTUE';
import { useDeviationViewContext } from '../../../../Context/DeviationViewContext';
import { DeviationTypes } from '../../../../types/deviation';
import s from './TierList.scss';
/** Sidebar block layout id 4 */
var TierList = function (_a) {
    var _b, _c;
    var block = _a.block, parentDeviation = _a.deviation;
    // TODO: bi shit
    var isMobile = useContext(MobileContext);
    var isTheater = useDeviationViewContext().isTheater;
    var parentTier = useSubscriptionTier(parentDeviation).tier;
    var _d = useSubscriptionLockFTUE(parentDeviation), isSubscriptionLockFTUEShown = _d.isSubscriptionLockFTUEShown, dropFlag = _d.dropFlag;
    // the non-lit ftue relies on having the sidebar on the right and not below, so only in !theater
    var isNonLit = ![
        DeviationTypes.JOURNAL,
        DeviationTypes.LITERATURE,
    ].includes(getDeviationType(parentDeviation));
    var isSelectedTierBlock = block.contentType === 'selectedTier' && !!parentTier;
    var isShowingSubscriptionsFTUE = !isSelectedTierBlock &&
        block.contentType === 'inTiers' &&
        isNonLit &&
        isSubscriptionLockFTUEShown &&
        !isMobile &&
        !isTheater;
    return (React.createElement(SidebarBlockWrapper, { deviation: parentDeviation, block: block },
        React.createElement(DeviationDuperbrowseContext, { streamId: "sidebar-tiers-" + block.contentType, deviations: (_b = block.deviations) !== null && _b !== void 0 ? _b : [], parent: {
                typeId: getDeviationResourceType(parentDeviation),
                itemId: parentDeviation.deviationId,
            } }, (_c = block.deviations) === null || _c === void 0 ? void 0 : _c.map(function (tier, i) {
            return isShowingSubscriptionsFTUE && i === 0 ? (React.createElement(SubscriptionLockFTUE, { dropFlag: dropFlag, className: s['ftue'], key: tier.deviationId, deviation: tier })) : (React.createElement(TierSidebarCard, { key: tier.deviationId, biData: {
                    evid: BiEventType.VIEW_TIER_UNIQUE,
                    referral_info: block.contentType === 'inTiers'
                        ? ReferralType.SIDE_BAR_CONTENT_PAGE
                        : ReferralType.SIDE_BAR_TIER_UNIQUE,
                    itemid: tier.deviationId,
                    typeid: ResourceType.TIER,
                }, className: s['tier'], deviation: tier }));
        }))));
};
TierList.displayName = 'TierList';
export default TierList;
//# sourceMappingURL=TierList.js.map